<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="userForm"
          :model="user"
          label-width="80px"
          size="small"
          class="box"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("prompt.dataUserAuth") }}
              <span class="grey font12">{{
                $t("prompt.dataUserAuthExplain")
              }}</span>
            </legend>
            <el-checkbox-group v-model="checkedUsers">
              <el-checkbox
                v-for="u of users"
                :key="u.id"
                :label="u.id"
                style="width: 110px"
              >
                <span :class="u.voidAt != null ? 'deleted' : ''">{{
                  Util.limitText(u.name, 6)
                }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </fieldset>
          <fieldset v-if="Permit.extendModels().includes('wms')" class="mgb15">
            <legend>
              {{ $t("prompt.dataWmsView") }}
              <span class="grey font12">{{
                $t("prompt.dataWmsViewExplain")
              }}</span>
            </legend>
            <el-checkbox-group v-model="checkedWmsView">
              <el-checkbox
                v-for="shop of shopsInv"
                :key="shop.id"
                :label="shop.id"
                style="width: 110px"
                >{{ Util.limitText(shop.name, 6) }}</el-checkbox
              >
            </el-checkbox-group>
          </fieldset>
          <fieldset v-if="Permit.extendModels().includes('wms')" class="mgb15">
            <legend>
              {{ $t("prompt.dataWmsManage") }}
              <span class="grey font12">{{
                $t("prompt.dataWmsManageExplain")
              }}</span>
            </legend>
            <el-checkbox-group v-model="checkedWmsManage">
              <el-checkbox
                v-for="shop of shopsInv"
                :key="shop.id"
                :label="shop.id"
                style="width: 110px"
                >{{ Util.limitText(shop.name, 6) }}</el-checkbox
              >
            </el-checkbox-group>
          </fieldset>
          <fieldset v-if="Permit.extendModels().includes('mms')" class="mgb15">
            <legend>
              {{ $t("menu.materials") }}{{ $t("menu.subjects") }}
              <span class="grey font12">{{
                $t("prompt.dataMmsSubjectAuthExplain")
              }}</span>
            </legend>
            <el-checkbox-group v-model="checkedSubjects">
              <el-checkbox
                v-for="subject of subjects"
                :key="subject.id"
                :label="subject.id"
                style="width: 110px"
                >{{ Util.limitText(subject.name, 6) }}</el-checkbox
              >
            </el-checkbox-group>
          </fieldset>
          <fieldset v-if="Permit.extendModels().includes('mes')" class="mgb15">
            <legend>
              {{ $t("dealTypes.manufacture") }}{{ $t("menu.phases") }}
              <span class="color-grey font12">{{
                $t("prompt.dataMesPhaseAuthExplain")
              }}</span>
            </legend>
            <el-checkbox-group v-model="checkedPhases">
              <el-checkbox
                v-for="phase of phases"
                :key="phase.id"
                :label="phase.id"
                style="width: 110px"
                >{{ Util.limitText(phase.name, 6) }}</el-checkbox
              >
            </el-checkbox-group>
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import User from "@/api/user.js";
import Shop from "@/api/shop.js";
import AuthTemplate from "@/api/authTemplate.js";
import Subject from "@/api/subject.js";
import UserAuth from "@/api/userAuth.js";
import Phase from "@/api/phase.js";
import Permission from "@/api/permission.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  data() {
    return {
      Util: Util,
      user: {},
      // checkedAuth: [],
      checkedUsers: [],
      shops: [],
      shopsInv: [],
      users: [],
      authTemplates: [],
      subjects: [],
      checkedSubjects: [],
      userAuthsMms: [],
      phases: [],
      checkedPhases: [],
      userAuthsMes: [],
      checkedWmsView: [],
      checkedWmsManage: [],
      saveDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    User.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.user = res.data.entity;
        // self.checkedAuth = JSON.parse(self.user.actionsJson || "[]");
        self.checkedUsers = JSON.parse(self.user.manageUsers || "[]");
        const permissions = self.user.permissions || [];
        if (
          self.Permit.extendModels().includes("wms") &&
          permissions.length != 0
        ) {
          const inventoryViewObj = permissions.find(
            (p) => p.permission == "inventoryView"
          );
          const inventoryManageObj = permissions.find(
            (p) => p.permission == "inventoryManage"
          );
          self.checkedWmsView = JSON.parse(inventoryViewObj.shops || "'[]'");
          self.checkedWmsManage = JSON.parse(
            inventoryManageObj.shops || "'[]'"
          );
        }
        self.getShops();
        self.getUsers();
        self.getAuthTemplates();
        if (self.Permit.extendModels().includes("mms")) {
          self.getMmsAuth();
        }
        if (self.Permit.extendModels().includes("mes")) {
          self.getMesAuth();
        }
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    saveSubmit() {
      const self = this;
      self.$refs.userForm.validate((valid) => {
        if (valid) {
          let obj = {
            manageUsers: JSON.stringify(self.checkedUsers),
          };
          self.saveDoing = true;
          User.updateManageUsers(self.id, obj).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              if (self.Permit.extendModels().includes("wms")) {
                self.saveSubmitWmsPermission();
              }
              if (self.Permit.extendModels().includes("mms")) {
                self.saveSubmitMmsUserAuth();
              }
              if (self.Permit.extendModels().includes("mes")) {
                self.saveSubmitMesUserAuth();
              }
              self.sysResult(res.data);
              self.$emit("updateInfo");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    saveSubmitWmsPermission() {
      const self = this;
      const data = [
        {
          permission: "inventoryView",
          shops: JSON.stringify(
            self.checkedWmsView.filter(
              (c) => self.shopsInv.find((s) => s.id == c) != null
            )
          ),
        },
        {
          permission: "inventoryManage",
          shops: JSON.stringify(
            self.checkedWmsManage.filter(
              (c) => self.shopsInv.find((s) => s.id == c) != null
            )
          ),
        },
      ];
      Permission.insertBatch(self.id, data).then(function (res) {
        if (res.status === 200) {
          // self.$message({
          //   message: self.$t("prompt.authSuccess"),
          //   type: "success"
          // });
        } else {
          self.sysError();
        }
      });
    },
    saveSubmitMmsUserAuth() {
      const self = this;
      const obj = {
        id: self.user.id,
        subjectsJson: JSON.stringify(self.checkedSubjects),
        actionsJson: JSON.stringify(self.userAuthsMms),
      };
      UserAuth.createMms(obj).then(function (res) {
        if (res.status === 200) {
          // self.$message({
          //   message: self.$t("prompt.authSuccess"),
          //   type: "success"
          // });
        } else {
          self.sysError();
        }
      });
    },
    saveSubmitMesUserAuth() {
      const self = this;
      const obj = {
        id: self.user.id,
        phasesJson: JSON.stringify(self.checkedPhases),
        actionsJson: JSON.stringify(self.userAuthsMes),
      };
      UserAuth.createMes(obj).then(function (res) {
        if (res.status === 200) {
          // self.$message({
          //   message: self.$t("prompt.authSuccess"),
          //   type: "success"
          // });
        } else {
          self.sysError();
        }
      });
    },

    getShops() {
      const self = this;
      Shop.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.shops = res.data;
          self.shopsInv = res.data.filter((s) => s.isInventory === true);
        } else {
          self.sysError();
        }
      });
    },
    getUsers() {
      const self = this;
      User.findByTenantId(self.Permit.currentTenant().id).then(function (res) {
        if (res.status === 200) {
          self.users = res.data.filter((u) => u.id !== self.user.id);
        } else {
          self.sysError();
        }
      });
    },
    getAuthTemplates() {
      const self = this;
      AuthTemplate.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.authTemplates = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getMmsAuth() {
      const self = this;
      axios.all([Subject.findByTenantId(), UserAuth.findByIdMms(self.id)]).then(
        axios.spread(function (subjects, userAuths) {
          if (subjects.status === 200) {
            self.subjects = subjects.data;
          } else {
            self.sysError();
          }
          if (userAuths.data.code === 200) {
            const userAuthsMms = userAuths.data.entity;
            self.checkedSubjects = JSON.parse(
              userAuthsMms.subjectsJson || "[]"
            );
            self.userAuthsMms = JSON.parse(userAuthsMms.actionsJson || "[]");
            // self.checkedAuth = self.checkedAuth.concat(
            //   JSON.parse(userAuthsMms.actionsJson || "[]")
            // );
          } else {
            // 其他是没有授权的
          }
        })
      );
    },
    getMesAuth() {
      const self = this;
      axios.all([Phase.findByTenantId(), UserAuth.findByIdMes(self.id)]).then(
        axios.spread(function (phases, userAuths) {
          if (phases.status === 200) {
            self.phases = phases.data;
          } else {
            self.sysError();
          }
          if (userAuths.data.code === 200) {
            const userAuthsMes = userAuths.data.entity;
            self.checkedPhases = JSON.parse(userAuthsMes.phasesJson || "[]");
            self.userAuthsMes = JSON.parse(userAuthsMes.actionsJson || "[]");
            // self.checkedAuth = self.checkedAuth.concat(
            //   JSON.parse(userAuthsMes.actionsJson || "[]")
            // );
          } else {
            // 其他是没有授权的
          }
        })
      );
    },
  },
};
</script>